import mapActions from "actions/map";
import modalActions from "actions/modal";
import PickerMap from "components/map/pickerMap";
import Loader from "components/shared/loader";
import React, { memo, useState } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { DefaultTemplate } from "../templates";

export default class MapPicker extends DefaultTemplate {
    componentDidMount() {
        this.setState({ isLoading: false, ...this.initialState });
    }

    renderBody = () => {
        const callback = (data) => {
            this.props.callback(data);
            this.close();
        };

        if (this.state.isLoading) {
            return <Loader />;
        }
        const PickerContainer = memo(
            withRouter(
                connect(
                    mapStateToProps,
                    mapDispatchToProps,
                )((props) => {
                    const [viewport, setViewport] = useState(props.viewport);

                    const mergeMapViewport = (payload) => setViewport({ ...viewport, ...payload });

                    return (
                        <PickerMap
                            {...props}
                            viewport={viewport}
                            mergeMapViewport={mergeMapViewport}
                            data={{ callback, withoutRadius: true, value: this.props.value }}
                        />
                    );
                }),
            ),
        );
        return <PickerContainer />;
    };
}

const mapStateToProps = (state) => ({
    mode: state.map.mode,
    viewport: state.map.viewport,
    data: state.map.data,
    fullscreen: state.layout.fullscreen,
    tileUrls: state.configs.tileUrls,
    params: state.map.params,
    organizationTimezone: state.profile.timezone,
    roles: state.profile.roles,
    enums: state.dictionaries.enums,
    profile: state.profile.profile,
    header: state.map.header,
});

const mapDispatchToProps = (dispatch) => ({
    switchMap: (params) => dispatch(mapActions.switchMap(params)),
    mergeMapData: (data) => dispatch(mapActions.mergeMapData(data)),
    changeCenter: (data) => dispatch(mapActions.changeCenter(data)),
    mergeParams: (data) => dispatch(mapActions.mergeParams(data)),
    modal: (params) => dispatch(modalActions.open(params)),
});
